import request from '@/utils/request'
export const getTaskType = () => {
  return request.get('/tasktype')
}
